import React, { Fragment, Component } from "react";

import Slider from "react-slick";

import bg4 from "../../../assets/utils/images/top-img.png";

import { Col, Row, Button, Form, FormGroup, Label, Input } from "reactstrap";
import { auth } from "../../../Auth/Firebase";
import { withRouter } from "react-router";
import { setAuthUser } from "../../../States/Token";
import { FaEyeSlash, FaRegEye } from "react-icons/fa";

class Register extends Component {
  constructor(props) {
    super(props);
    this.state = {
      email: "",
      password: "",
      confirm_password: "",
      message: "",
      accepted_terms: false,
      disable_input: false,
      show_password: false,
      show_repeat_password: false,
    }

    this.createUserWithEmailAndPasswordHandler = this.createUserWithEmailAndPasswordHandler.bind(this);
  }

  createUserWithEmailAndPasswordHandler = async (email, password, confirm_password) => {
    this.setState({message: ""});
    if (!email.trim()) {
      this.setState({message: 'Email cannot be empty.'});
      return;
    }
    if (!password.trim()) {
      this.setState({message: 'Password cannot be empty.'});
      return;
    }
    if (password != confirm_password) {
      this.setState({message: 'Password and Repeat password do not match.'});
      return;
    }
    if (!this.state.accepted_terms) {
      this.setState({message: 'Please review the terms of use.'});
      return;
    }
    this.setState({disable_input: true});
    try{
      const {user} = await auth.createUserWithEmailAndPassword(email, password);
      setAuthUser(user);
      this.props.history.push('/auth/login');
      this.setState({disable_input: false});
    }
    catch(error){
      this.setState({message: error.message});
      this.setState({disable_input: false});
    }
  }

  handleEnterPress = (event, callback) => {
    if(event.key === 'Enter'){
      callback();
    }
  }

  render() {
    let settings = {
      dots: true,
      infinite: true,
      speed: 500,
      arrows: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      fade: true,
      initialSlide: 0,
      autoplay: true,
      adaptiveHeight: true,
    };
    return (
      <Fragment>
        <div className="login-main">
        <div className="login-video">
  <video
    autoPlay
    loop
    muted
    className="sample-video h-100 no-gutters"
  >
    <source
      src="https://client-static.saleassist.ai/74c28198-7762-40d3-8925-5cc00dc99e98/hb-opt.mp4"
      type="video/mp4"
    />
    Your browser does not support the video tag.
  </video>
</div>
        <div className="login-form h-100">
          <Row className="h-100 no-gutters">
            <Col className="h-100 d-flex bg-white justify-content-center align-items-center col-md-12 col-lg-12">
              <Col lg="9" md="10" sm="12" className="mx-auto app-login-box" style={{textAlign: "center"}}>
                {/* <div className="app-block-logo" /> */}
                <div> <img
                src="https://client-static.saleassist.ai/74c28198-7762-40d3-8925-5cc00dc99e98/sa-new-Logo.png"
                alt="SaleAssist Logo"
                style={{ width: "200px",margin:"auto"}} // Set size and margin for logo
              />
              </div>
              <Row className="divider" />
              <h3 style={{textAlign:"center"}}>Create A New Account</h3>
                <h6 className="mt-3 text-danger">
                  {this.state.message}
                </h6>
                <div style={{ color: "grey",
                      backgroundColor: "white",
                      border: "none",
                      borderRadius: "0.25rem",
                      boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",  // Adds a subtle shadow for the card effect
                      padding: "10px 15px",  // Adds some padding to make it feel more like a card
                      backgroundSize: "contain",}}>
                  <Form onSubmit={(e) => e.preventDefault()}>
                    <Row form>
                      <Col md={12}>
                        <FormGroup style={{ textAlign: "left" }}>
                          <Label for="exampleEmail">
                            <span className="text-danger">*</span> Email
                          </Label>
                          <Input type="email" name="email" id="exampleEmail" placeholder="Email here..." 
                            disabled={this.state.disable_input}
                            onChange={(e) => {this.setState({email: e.target.value})}} value={this.state.email} 
                            onKeyPress={(e) => this.handleEnterPress(e, () => {this.createUserWithEmailAndPasswordHandler(this.state.email, this.state.password, this.state.confirm_password)})}
                          />
                        </FormGroup>
                      </Col>
                      <Col md={6}>
                        <FormGroup style={{ textAlign: "left", position: "relative" }}>
                          <Label for="examplePassword">
                            <span className="text-danger">*</span> Password
                          </Label>
                          <Input type={!this.state.show_password ? "password" : "text"} name="password" id="examplePassword" placeholder="Password here..." 
                            disabled={this.state.disable_input}
                            onChange={(e) => {this.setState({password: e.target.value})}} value={this.state.password} 
                            onKeyPress={(e) => this.handleEnterPress(e, () => {this.createUserWithEmailAndPasswordHandler(this.state.email, this.state.password, this.state.confirm_password)})}
                          />
                           {this.state.show_password ? 
                              <FaRegEye onClick={() => this.setState({show_password: !this.state.show_password})} style={{ position: "absolute", bottom: "10px", right: "10px", cursor: "pointer" }} />
                              : <FaEyeSlash onClick={() => this.setState({show_password: !this.state.show_password})} style={{ position: "absolute", bottom: "10px", right: "10px", cursor: "pointer" }} />
                            }
                        </FormGroup>
                      </Col>
                      <Col md={6}>
                        <FormGroup style={{ textAlign: "left", position: "relative" }}>
                          <Label for="examplePasswordRep">
                            <span className="text-danger">*</span> Repeat
                            Password
                          </Label>
                          <Input type={!this.state.show_repeat_password ? "password" : "text"} name="passwordrep" id="examplePasswordRep" placeholder="Repeat Password here..." 
                            disabled={this.state.disable_input}
                            onChange={(e) => {this.setState({confirm_password: e.target.value})}} value={this.state.confirm_password} 
                            onKeyPress={(e) => this.handleEnterPress(e, () => {this.createUserWithEmailAndPasswordHandler(this.state.email, this.state.password, this.state.confirm_password)})}
                          />
                          {this.state.show_repeat_password ? 
                            <FaRegEye onClick={() => this.setState({show_repeat_password: !this.state.show_repeat_password})} style={{ position: "absolute", bottom: "10px", right: "10px", cursor: "pointer" }} />
                            : <FaEyeSlash onClick={() => this.setState({show_repeat_password: !this.state.show_repeat_password})} style={{ position: "absolute", bottom: "10px", right: "10px", cursor: "pointer" }} />
                          }
                        </FormGroup>
                      </Col>
                    </Row>
                    <FormGroup className="mt-1" check  style={{ textAlign: "left" }}>
                      <Input type="checkbox" name="check" checked={this.state.accepted_terms} onClick={(e) => {this.setState({accepted_terms: !this.state.accepted_terms})}} id="accepted_terms" />
                      <Label for="accepted_terms" check>
                        Accept our{" "}
                        <a href="https://saleassist.ai/Terms-Conditions" target="_blank">
                          Terms of use
                        </a>
                        .
                      </Label>
                    </FormGroup>
                    <div className="mt-4 d-flex align-items-center">
                      
                      <div className="ml-auto">
                        <Button color="primary" disabled={this.state.disable_input} className="login-btn btn-shadow btn-hover-shine" size="lg" onClick={(e) => {e.preventDefault(); this.createUserWithEmailAndPasswordHandler(this.state.email, this.state.password, this.state.confirm_password)}}>
                          Create Account
                        </Button>
                      </div>
                    </div>
                    <div  style={{textAlign:"center"}}>
                    <h6 className=" mb-3 mt-4 ">
                        Already have an account?{" "}
                        <a href="#" onClick={(e) => {e.preventDefault(); this.props.history.push('/auth/login')}}
                         style={{fontSize:"13px",fontWeight:"bolder",color:"black"}} >
                          SIGN IN
                          <i className="fas fa-arrow-right" style={{ marginLeft: '8px' }}></i>
                        </a>
                      </h6>
                    </div>
                    
                  </Form>
                </div>
              </Col>
            </Col>
            
          </Row>
        </div>
        </div>
        
      </Fragment>
    );
  }
}

export default withRouter(Register);